import React from "react";
import Typography from "@material-ui/core/Typography";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import RegularButton from "../../../components/buttons/RegularButton";
import { Link } from "react-router-dom";

export default function SelfOrder() {
  const benefits = [
    "Pemesanan mandiri nirsentuh lewat kode QR",
    "Mendukung pembayaran QRIS & seluruh e-Wallet",
    "Katalog menu interaktif dengan foto & varian",
    "Fitur split bill otomatis per pelanggan",
    "Notifikasi pesanan siap ambil",
    "Program kupon diskon & loyalty points",
  ];

  return (
    <section
      style={{
        padding: "80px 0",
        backgroundColor: "#0f172a",
        color: "#ffffff",
        borderTop: "1px solid #1e293b",
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={6} alignItems="center" justify="space-between">
          {/* Left Text & Benefits */}
          <Grid item xs={12} md={6}>
            <div
              style={{
                color: "#38bdf8",
                fontSize: "13px",
                fontWeight: 600,
                textTransform: "uppercase",
                letterSpacing: "0.05em",
                marginBottom: "12px",
              }}
            >
              Fitur Self Order
            </div>

            <Typography
              variant="h2"
              style={{
                fontWeight: 800,
                fontSize: "clamp(1.8rem, 3.5vw, 2.6rem)",
                lineHeight: 1.25,
                letterSpacing: "-0.02em",
                marginBottom: "16px",
              }}
            >
              Pesan Langsung dari Meja, Bebas Antrian
            </Typography>

            <Typography
              variant="body1"
              style={{
                color: "#94a3b8",
                fontSize: "15px",
                lineHeight: 1.7,
                marginBottom: "28px",
              }}
            >
              Pelanggan cukup memindai kode QR yang terpasang di meja untuk melihat menu digital, menentukan pesanan, dan melakukan pembayaran instan tanpa perlu menunggu pelayan datang.
            </Typography>

            {/* Clean bullet list */}
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "12px",
                marginBottom: "36px",
              }}
            >
              {benefits.map((item, idx) => (
                <div
                  key={idx}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                  }}
                >
                  <span
                    style={{
                      width: "18px",
                      height: "18px",
                      borderRadius: "50%",
                      backgroundColor: "rgba(56, 189, 248, 0.15)",
                      color: "#38bdf8",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: "11px",
                      fontWeight: 700,
                      flexShrink: 0,
                    }}
                  >
                    ✓
                  </span>
                  <span style={{ color: "#e2e8f0", fontSize: "14px", fontWeight: 500 }}>
                    {item}
                  </span>
                </div>
              ))}
            </div>

            {/* Action Buttons */}
            <div style={{ display: "flex", gap: "12px", flexWrap: "wrap", alignItems: "center" }}>
              <RegularButton
                text="Download Aplikasi UR"
                href="https://play.google.com/store/apps/details?id=com.urpartner"
              />
              <Button
                component={Link}
                to="/partner"
                style={{
                  color: "#ffffff",
                  borderRadius: "10px",
                  padding: "12px 20px",
                  textTransform: "none",
                  fontWeight: 600,
                  fontSize: "14px",
                  border: "1px solid rgba(255, 255, 255, 0.2)",
                  backgroundColor: "transparent",
                }}
              >
                Pelajari Lebih Lanjut
              </Button>
            </div>
          </Grid>

          {/* Right Phone Mockup */}
          <Grid item xs={12} md={5} style={{ textAlign: "center" }}>
            <img
              src="./asset/images/banner/selfOrder.png"
              alt="Aplikasi Self Order UR"
              style={{
                maxHeight: "480px",
                width: "auto",
                filter: "drop-shadow(0 20px 30px rgba(0, 0, 0, 0.5))",
              }}
            />
          </Grid>
        </Grid>
      </Container>
    </section>
  );
}
